export enum TrackTypes {
  BASIC = 'basic',
  BASIC_PERSONAL = 'basic-personal',
  BASIC_MARITAL = 'basic-marital',
  BASIC_ADDRESS = 'basic-address',
  BASIC_PROFESSIONAL = 'basic-professional',
  BASIC_INCOME = 'basic-income',
  BASIC_PROFILE = 'basic-profile',

  BASIC_V2 = 'basic-v2',
  BASIC_PERSONAL_V2 = 'basic-personal-v2',
  BASIC_MARITAL_V2 = 'basic-marital-v2',
  BASIC_ADDRESS_V2 = 'basic-address-v2',
  BASIC_PROFESSIONAL_V2 = 'basic-professional-v2',
  BASIC_INCOME_V2 = 'basic-income-v2',
  BASIC_PROFILE_V2 = 'basic-profile-v2',
  
  EXPERIMENTATION = 'Experimentation',
  CONTA_ION = 'contaion',
  CONTA_ION_PERSONAL = 'contaion-personal',
  CONTA_ION_MARITAL = 'contaion-marital',
  CONTA_ION_ADDRESS = 'contaion-address',
  CONTA_ION_PROFESSIONAL = 'contaion-professional',
  CONTA_ION_INCOME = 'contaion-income',

  UPDATE_REGISTRATION = 'update-registration',
  UPDATE_INCOME = 'update-income',
  UPDATE_INCOME_CONTA_ION = 'update-income-conta-ion',
  UPDATE_MARITAL = 'update-marital',
  UPDATE_ADDRESS = 'update-address',
  UPDATE_PROFILE = 'update-profile',
  UPDATE_PROFESSIONAL = 'update-professional',

  FIRST_ACCESS = 'first-access'
}
